import { Component, OnInit } from '@angular/core';
import { RouterLinkActive, Router } from '@angular/router';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
	menu_user;
  constructor() { }

  ngOnInit(){
  	this.menu_user = JSON.parse(localStorage.getItem('menu_user')); 	
  }

 

}
